import axios from "axios";

export const fetchAllNotifications = async (fetchUnread) => {
  const { data } = await axios.post(`/api/notifications`, { fetchUnread });
  return data; // Ensure the data is returned
};

export const createNotification = notification => {
  return axios.post(`/api/notifications`, notification)
};

export const updateNotificationRead = () => {
  return axios.put(`/api/notifications`)
};

//Fetching some data from our server using props passed down from ProfileTab. 
//This function is being used in notification_actions
export const fetchUserNotifications = async (username, cancelToken) => {
  try {
    const { data } = await axios.get(`/api/notifications/activity?username=${username}`, { cancelToken })
    console.log("user notifications in fetchUserNotifications user_actions", data)
    return data
  } catch (error) {
    throw error
  }
};